// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"c351b982","177":"1fd4d75c","579":"818e31f8","601":"7183bae0","700":"25e4f5ea","800":"a8f6ff22","861":"d647444b","888":"53bd666a"}[chunkId] + ".chunk.js";
};